<agpr-panel header="Briefing.onlineBriefing.settings.type">
    <agpr-radio
        [id]="id + '.canvasSetup.type.oneOff'"
        name="canvasSetupType"
        [value]="deliveryTypes.immediate"
        [label]="'Briefing.onlineBriefing.settings.oneOff'"
        [tooltip]="'Briefing.onlineBriefing.settings.oneOff.tooltip'"
        [(ngModel)]="canvasPreview.deliverySchedulingType"
        (ngModelChange)="typeChanged($event)"
    ></agpr-radio>
    <agpr-radio
        [id]="id + '.canvasSetup.type.recurring'"
        name="canvasSetupType"
        [value]="deliveryTypes.recurring"
        [label]="'Briefing.onlineBriefing.settings.recurring'"
        [tooltip]="'Briefing.onlineBriefing.settings.recurring.tooltip'"
        [(ngModel)]="canvasPreview.deliverySchedulingType"
        (ngModelChange)="typeChanged($event)"
    ></agpr-radio>
</agpr-panel>

<agpr-panel header="Briefing.onlineBriefing.settings.competitor.representing">
    <agpr-monitoring-brand-card
        #brandCardTemp
        [id]="'agpr_briefingCanvasTemplateSetup_brandCard'"
        [showLogoField]="true"
        [dataSourceConfigs]="brandCardDataSourceConfigs"
        [isGlobalDateRange]="true"
        [monthlyConfigs]="monthlyConfigs"
        [quarterlyConfigs]="quarterlyConfigs"
        [showRecentColors]="true"
        [(ngModel)]="brandCard"
        (ngModelChange)="onBrandCardChanged()"
        (brandSelected)="populateCompetitors()"
    ></agpr-monitoring-brand-card>
</agpr-panel>

<agpr-panel header="Briefing.onlineBriefing.settings.coverageSource">
    <div #brandCardDataSourceRef>
        <ng-container *ngTemplateOutlet="brandCardTemp.dataSourcePicker()"></ng-container>
    </div>
</agpr-panel>

@if (canvasPreview.template === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_COMPETITOR) {
    <agpr-panel header="Briefing.onlineBriefing.settings.competitor.competitors" [canOnlyClickIcon]="true">
        <ng-template #panelHeader>
            <agpr-button
                [id]="id + '.canvasSetup.competitor.add'"
                class="agpr-briefingCanvasTemplateSetup-addCompetitorButton"
                [style]="buttonTypesEnum.icon"
                icon="fa-regular fa-duotone fa-square-plus"
                ariaLabel="Briefing.onlineBriefing.settings.competitor.add"
                [tooltip]="canvasPreview.competitors.length > 10 ? 'Briefing.onlineBriefing.settings.competitor.limit' : 'Briefing.onlineBriefing.settings.competitor.add'"
                [disabled]="canvasPreview.competitors.length > 10"
                tooltipPosition="left"
                (click)="addCompetitor()"
            ></agpr-button>
        </ng-template>
        @for (competitor of canvasPreview.competitors; track i; let i = $index) {
            @let id = competitor?.brand?.id;
            <div #competitorCard class="agpr-briefingCanvasTemplateSetup-competitorCard agpr-contextMenu-parent">
                <agpr-monitoring-brand-card
                    [id]="'agpr_briefingCanvasTemplateSetup_competitorCard_' + i"
                    [hideBorder]="true"
                    [toggleButtonLabel]="'Briefing.onlineBriefing.settings.competitor.toggle'"
                    [showDataSourceField]="true"
                    [dataSourceConfigs]="competitorCardDataSourceConfigs"
                    [showRecentColors]="true"
                    [ngModel]="competitor"
                    (ngModelChange)="onCompetitorCardChanged($event, i)"
                ></agpr-monitoring-brand-card>
                <div class="agpr-contextMenu right bottom">
                    @if (!$first) {
                        <agpr-button
                            [id]="'agpr_briefingCanvasTemplateSetup_competitorCard_' + i + '_moveUp'"
                            [style]="buttonTypesEnum.contextMenu"
                            icon="fa-regular fa-arrow-up"
                            tooltip="Common.brandIdentity.manageDialog.button.moveUp"
                            tooltipPosition="top"
                            (click)="moveUp(i)"
                        ></agpr-button>
                    }
                    @if (!$last) {
                        <agpr-button
                            [id]="'agpr_briefingCanvasTemplateSetup_competitorCard_' + i + '_moveDown'"
                            [style]="buttonTypesEnum.contextMenu"
                            icon="fa-regular fa-arrow-down"
                            tooltip="Common.brandIdentity.manageDialog.button.moveDown"
                            tooltipPosition="top"
                            (click)="moveDown(i)"
                        ></agpr-button>
                    }
                    @if (canvasPreview.competitors.length > 1) {
                        <agpr-button
                            [id]="'agpr_briefingCanvasTemplateSetup_competitorCard_' + i + '_deleteButton'"
                            [style]="buttonTypesEnum.contextMenu"
                            icon="fa-regular fa-duotone fa-square-xmark"
                            tooltip="DataConnector.contextMenu.delete"
                            tooltipPosition="top"
                            (click)="deleteCompetitor(i)"
                        ></agpr-button>
                    }
                </div>
            </div>
            @if (id !== null && id !== undefined && duplicateBrandIds[id]) {
                <agpr-message [severity]="messageSeverityEnum.error">
                    {{ 'Briefing.onlineBriefing.settings.competitor.duplicateBrand' | localize }}
                </agpr-message>
            }
        }
    </agpr-panel>
}

@if (canvasPreview.allowAi) {
    <agpr-panel header="Briefing.onlineBriefing.settings.prCoPilot" headerIcon="fa-light fa-brain-circuit">
        <agpr-text-input
            [id]="id + '.canvasSetup.analysisFocus'"
            [label]="'Briefing.onlineBriefing.settings.analysisFocus'"
            [placeholder]="'Briefing.onlineBriefing.settings.analysisFocus.placeholder'"
            [tooltip]="canvasPreview.template === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_COMPETITOR
                ? 'Briefing.onlineBriefing.settings.analysisFocus.competitor.tooltip'
                : 'Briefing.onlineBriefing.settings.analysisFocus.tooltip'"
            [maxLength]="analysisFocusMaxLength"
            [(ngModel)]="canvasPreview.analysisFocus"
            (ngModelChange)="analysisFocusChanged($event)"
        ></agpr-text-input>
    </agpr-panel>
}
